import { getToken } from "../../helpers/get-token";
import axiosInstance from "../../axios/instance";

async function getAllAccessLevels() {
    try {
        const token = getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;
        const response = await axiosInstance.get(process.env.REACT_APP_HUB_URL + '/api/access-levels/all')
        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export default getAllAccessLevels;
